<template>
	<div class="d_i_b">
		<el-upload class="daoru_button" :action="image_up+action" :name="name" :data="{user_token:user_token,...datas}" :show-file-list="false"  :before-upload="before_upload" :on-success="on_success" :on-error="on_error">
		    <el-button type="primary" size="mini">{{title}}</el-button>
		</el-upload>
	    <el-button size="mini" v-if="download" @click="click_download">{{subTitle||title+'模板'}}</el-button>
	</div>
</template>
<script>
const config = require('../../vue.config');
export default {
	name: 'upload_import',
	data() {
		return {
			image_up:process.env.API_UP,
			user_token:sessionStorage.getItem('user_token'),
			loading:null,
		}
	},
	props: {
		// 导入地址
		action: {
			type:String,
			default:''
		},
		// 模板下载地址
		download:{
			type:String,
			default:''
		},
		// 显示文字
		title:{
			type:String,
			default:''
		},
		// 显示文字(副标题)
		subTitle:{
			type:String,
			default:''
		},
		// 导入的key名
		name: {
			type:String,
			default:'file'
		},
		// 附加参数
		datas: {
			type:Object,
			default:()=>{}
		},

	},
	watch: {},
	mounted() {},
	methods: {
		before_upload(file){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		on_success(res,file){
			if (res.status==200) {
				this.$message.success('导入成功');
				this.$emit('change',res&&res.data);
			}else{
				this.$message.error(res.message);
			}
			this.loading.close();
		},
		on_error(res){
			console.log(res);
			this.$message.error('接口错误');
			this.loading.close();
		},
		// 下载模板
		click_download(){
			let link = document.createElement("a");
			var url = config.download+'download/'+this.download;
			link.href = url;
			console.log(url)
			var suffix = this.download.split('.');
			console.log(suffix)
			link.download = (this.subTitle||this.title)+'.'+(suffix.length>0?suffix[suffix.length-1]:'xlsx');
			link.target = '_blank';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
}
</script>
<style lang="css">
.d_i_b{
	line-height: 1;
	display: inline-block;
}	
.daoru_button{
	display: inline-block;
}
.daoru_button .el-upload{
	margin-bottom: 0;
}
.el-button+.el-button,
.daoru_button+.el-button,
.daoru_button+.daoru_button,
.el-button+.daoru_button{
	margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload_import.vue